(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["bellucco-area-cliente"] && !Shopify.designMode) return;
  try {
    
(() => {
  const MAX_UPLOAD_BYTES = 5 * 1024 * 1024;
  const IDLE_LIMIT_MS = 30 * 60 * 1000;
  // Durata massima della sessione dall'accesso (come indicato nell'informativa privacy), indipendente dall'attività.
  const SESSION_LIMIT_MS = 30 * 60 * 1000;
  const roots = document.querySelectorAll('[data-bellucco-portal]');
  roots.forEach((root) => {
    const api = root.dataset.api;
    const apiHost = (() => { try { return new URL(api).host; } catch { return 'help.bellucco.net'; } })();
    const key = 'bellucco_customer_token_v1';
    const emailKey = 'bellucco_customer_email_v1';
    const challengeKey = 'bellucco_customer_otp_challenge_v1';
    const loginAtKey = 'bellucco_customer_login_at_v1';
    const sessionMemory = new Map();
    const sessionRead = k => {
      if (sessionMemory.has(k)) return sessionMemory.get(k);
      try { return sessionStorage.getItem(k) || ''; } catch { return ''; }
    };
    const sessionWrite = (k, value) => {
      sessionMemory.set(k, String(value));
      try { sessionStorage.setItem(k, String(value)); } catch {}
    };
    const sessionRemove = k => {
      sessionMemory.set(k, '');
      try { sessionStorage.removeItem(k); } catch {}
    };
    let email = sessionRead(emailKey);
    let data = null;
    let lastActivity = Date.now();
    const $ = (sel) => root.querySelector(sel);
    const $$ = (sel) => [...root.querySelectorAll(sel)];

    // Messaggio generale in cima (accesso, sessione, uscita).
    const topMessage = (text, error = false) => {
      const el = $('[data-message]');
      el.textContent = text;
      el.hidden = !text;
      el.classList.toggle('is-error', error);
      if (text) el.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
    };
    // Messaggio accanto al pulsante premuto, così non serve scorrere.
    const showStatus = (el, text, kind = '') => {
      if (!el) return;
      el.textContent = text;
      el.hidden = !text;
      el.classList.toggle('is-error', kind === 'error');
      el.classList.toggle('is-success', kind === 'success');
      if (text) {
        el.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
        try { el.focus({ preventScroll: true }); } catch {}
      }
    };
    const formStatus = (form) => form.querySelector('[data-form-status]');

    const token = () => sessionRead(key) || '';
    const bbSafeMsg = (m, f) => { m = typeof m === 'string' ? m.trim() : ''; return m && m.length <= 200 && !/[<>{}\[\]\\$=`|]|https?:|\.php|(^|[\s(])\/\w|\b(sql|php|pdo|mysql|exception|stack|trace|fatal|warning|notice|undefined|errno|apache|nginx|linux|aruba|server|token|api)\b/i.test(m) ? m : f; };
    const call = async (action, options = {}) => {
      const headers = { ...(options.headers || {}) };
      if (!(options.body instanceof FormData)) headers['Content-Type'] = 'application/json';
      if (token()) headers['X-Bellucco-Token'] = token();
      const { timeout = 30000, ...rest } = options;
      // Il tempo massimo copre l'intera richiesta: invio, risposta e lettura del corpo.
      const controller = new AbortController();
      const limit = setTimeout(() => controller.abort(), timeout);
      let res, body;
      try {
        res = await fetch(`${api}?action=${encodeURIComponent(action)}`, { ...rest, headers, credentials: 'omit', signal: controller.signal });
        body = await res.json().catch(() => ({ ok: false }));
      } catch (e) {
        if (e && e.name === 'BBCaptchaError') throw e;
        throw new Error(e && e.name === 'AbortError' ? 'Il servizio non ha risposto in tempo. Riprova tra poco.' : 'Connessione non riuscita. Controlla la rete e riprova.');
      } finally {
        clearTimeout(limit);
      }
      if (!res.ok || body.ok === false) {
        const error = new Error(bbSafeMsg(body.error, res.status === 429 ? 'Troppi tentativi. Attendi qualche minuto e riprova.' : 'Operazione non riuscita. Riprova tra poco.'));
        error.status = res.status;
        throw error;
      }
      return body;
    };
    const setTab = (name, moveFocus = false) => {
      $$('[data-tab]').forEach((b) => {
        const active = b.dataset.tab === name;
        b.classList.toggle('is-active', active);
        b.setAttribute('aria-selected', active ? 'true' : 'false');
        b.tabIndex = active ? 0 : -1;
        if (active && moveFocus) b.focus();
      });
      $$('[data-panel]').forEach((p) => {
        const active = p.dataset.panel === name;
        p.classList.toggle('is-active', active);
        p.hidden = !active;
      });
    };
    const esc = (value) => String(value ?? '').replace(/[&<>"']/g, (c) => ({ '&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#039;' }[c]));

    const safeDocUrl = (raw) => {
      try {
        const url = new URL(String(raw || ''), api);
        return url.protocol === 'https:' && url.host === apiHost ? url : null;
      } catch { return null; }
    };

    const render = () => {
      if (!data) return;
      $('[data-customer-name]').textContent = data.customer.name ? `Ciao, ${data.customer.name}` : 'Area Cliente';
      $('[data-count="practices"]').textContent = data.practices.length;
      $('[data-count="documents"]').textContent = data.documents.length;
      $('[data-count="privacy"]').textContent = data.privacy_requests.length;
      const pf = $('[data-form="profile"]');
      ['email','name','phone','address','city'].forEach((n) => { if (pf.elements[n]) pf.elements[n].value = data.customer[n] || ''; });
      $('[data-practices]').innerHTML = data.practices.length ? `<div class="bellucco-portal__list">${data.practices.map((p) => `<div class="bellucco-portal__item"><div><strong>${esc(p.code)}</strong><small>${esc(p.service || 'Richiesta')}</small></div><span class="bellucco-portal__status">${esc(p.status || 'In gestione')}</span></div>`).join('')}</div>` : '<p class="bellucco-portal__empty">Nessuna pratica disponibile.</p>';
      $('[data-documents]').innerHTML = data.documents.length ? `<div class="bellucco-portal__list">${data.documents.map((d, i) => `<div class="bellucco-portal__item"><div><strong>${esc(d.label)}</strong><small>${esc(d.practice || '')}</small></div>${safeDocUrl(d.download_url) ? `<button type="button" class="bellucco-portal__button bellucco-portal__button--light" data-open-doc="${i}">Apri</button>` : '<span class="bellucco-portal__status">Non disponibile</span>'}</div>`).join('')}</div>` : '<p class="bellucco-portal__empty">Nessun documento pubblicato per te.</p>';
      $('[data-privacy-list]').innerHTML = data.privacy_requests.length ? `<div class="bellucco-portal__list" style="margin-top:18px">${data.privacy_requests.map((r) => `<div class="bellucco-portal__item"><div><strong>${esc(r.code)}</strong><small>${esc(r.type)}</small></div><span class="bellucco-portal__status">${esc(r.status)}</span></div>`).join('')}</div>` : '';
    };
    let sessionEpoch = 0;
    const load = async () => {
      const epoch = sessionEpoch;
      const out = await call('me');
      if (epoch !== sessionEpoch || !token()) return;
      data = out;
      $('[data-login]').hidden = true;
      $('[data-app]').hidden = false;
      $('[data-action="logout"]').hidden = false;
      render();
    };

    // Controllo del PDF nel browser, prima dell'invio.
    const checkPdf = async (file) => {
      if (!file || !file.name) return { error: 'Seleziona un file PDF.' };
      if (!/\.pdf$/i.test(file.name)) return { error: 'Puoi caricare solo file PDF.' };
      if (file.type && file.type !== 'application/pdf') return { error: 'Il file selezionato non è un PDF.' };
      if (file.size === 0) return { error: 'Il file è vuoto.' };
      if (file.size > MAX_UPLOAD_BYTES) return { error: `Il file pesa ${(file.size / 1048576).toFixed(1)} MB: il massimo è 5 MB. Prova a ridurlo o a dividerlo in più file.` };
      let bytes;
      try { bytes = new Uint8Array(await file.arrayBuffer()); } catch { return { error: 'Impossibile leggere il file. Riprova.' }; }
      const text = new TextDecoder('windows-1252').decode(bytes);
      if (!text.startsWith('%PDF-')) return { error: 'Il file non è un PDF valido.' };
      if (!text.slice(-2048).includes('%%EOF')) return { error: 'Il PDF sembra danneggiato o incompleto.' };
      if (/\/Encrypt\b/.test(text)) return { error: 'I PDF protetti da password non sono accettati. Salvalo senza protezione e riprova.' };
      if (/\/(JavaScript|JS|Launch|RichMedia)\b/.test(text)) return { error: 'Il PDF contiene script e non può essere accettato. Stampalo di nuovo in PDF e riprova.' };
      return { bytes };
    };

    const pendingForms = new WeakSet();
    const onSubmit = (name, action) => {
      const form = $(`[data-form="${name}"]`);
      if (!form) return;
      form.addEventListener('submit', async event => {
        event.preventDefault();
        if (pendingForms.has(form) || !form.reportValidity()) return;
        pendingForms.add(form);
        const buttons = [...form.querySelectorAll('button[type="submit"], input[type="submit"]')];
        const wasDisabled = buttons.map(button => button.disabled);
        const labels = buttons.map(button => button.textContent);
        buttons.forEach(button => { button.disabled = true; button.textContent = 'Attendere…'; });
        form.setAttribute('aria-busy', 'true');
        try {
          await action(event, form);
        } finally {
          buttons.forEach((button, index) => { button.disabled = wasDisabled[index]; button.textContent = labels[index]; });
          form.removeAttribute('aria-busy');
          pendingForms.delete(form);
        }
      });
    };

    onSubmit('request-otp', async (ev, form) => {
      email = new FormData(form).get('email').toString().trim().toLowerCase();
      sessionWrite(emailKey, email);
      try {
        const cfToken = window.bbCaptcha ? await window.bbCaptcha.token() : '';
        const out = await call('request_otp', { method:'POST', body:JSON.stringify(cfToken ? { email, cf_turnstile: cfToken } : { email }) });
        if (!out.challenge) throw new Error('Impossibile iniziare la verifica. Richiedi un nuovo codice.');
        sessionWrite(challengeKey, out.challenge);
        showStatus(formStatus(form), bbSafeMsg(out.message, 'Codice inviato. Controlla la tua email.'), 'success');
        $('[data-otp-card]').hidden = false;
      } catch (err) { showStatus(formStatus(form), err.message, 'error'); }
    });
    onSubmit('verify-otp', async (ev, form) => {
      try {
        const challenge = sessionRead(challengeKey) || '';
        if (!challenge) throw new Error('Richiedi un nuovo codice di accesso.');
        const code = new FormData(form).get('code').toString().trim();
        const out = await call('verify_otp', { method:'POST', body:JSON.stringify({ challenge, code }) });
        sessionWrite(key, out.token);
        sessionRemove(challengeKey);
        sessionWrite(loginAtKey, Date.now());
        lastActivity = Date.now();
        await load();
        topMessage('Accesso effettuato.');
      } catch (err) { showStatus(formStatus(form), err.message, 'error'); }
    });
    onSubmit('profile', async (ev, form) => {
      const payload = Object.fromEntries(new FormData(form).entries());
      try { await call('update_profile', { method:'POST', body:JSON.stringify(payload) }); await load(); showStatus(formStatus(form), 'Dati aggiornati.', 'success'); }
      catch (err) { showStatus(formStatus(form), err.message, 'error'); }
    });
    onSubmit('privacy', async (ev, form) => {
      const payload = Object.fromEntries(new FormData(form).entries());
      try { const out = await call('privacy_request', { method:'POST', body:JSON.stringify(payload) }); form.reset(); await load(); showStatus(formStatus(form), `Richiesta registrata: ${out.code}.`, 'success'); }
      catch (err) { showStatus(formStatus(form), err.message, 'error'); }
    });
    onSubmit('generic-request', async (ev, form) => {
      const payload = Object.fromEntries(new FormData(form).entries());
      try { const out = await call('generic_request', { method:'POST', body:JSON.stringify(payload) }); form.reset(); showStatus(formStatus(form), `Richiesta inviata: ${out.code}.`, 'success'); }
      catch (err) { showStatus(formStatus(form), err.message, 'error'); }
    });
    onSubmit('upload', async (ev, form) => {
      const status = formStatus(form);
      showStatus(status, 'Controllo del file in corso…');
      const fd = new FormData(form);
      const checked = await checkPdf(fd.get('document'));
      if (checked.error) { showStatus(status, checked.error, 'error'); return; }
      const clean = new FormData();
      clean.append('label', String(fd.get('label') || '').trim().slice(0, 120));
      clean.append('practice', String(fd.get('practice') || '').trim().slice(0, 20));
      clean.append('document', new File([checked.bytes], 'documento.pdf', { type: 'application/pdf' }));
      showStatus(status, 'Invio del documento in corso…');
      try {
        await call('upload', { method:'POST', body: clean, timeout: 120000 });
        form.reset();
        await load();
        showStatus(status, 'Documento caricato correttamente. Lo trovi nell\'elenco qui sopra.', 'success');
      } catch (err) { showStatus(status, err.message, 'error'); }
    });

    const docStatus = $('[data-documents-status]');
    const sniffType = (bytes) => {
      const head = new TextDecoder('windows-1252').decode(bytes.slice(0, 12));
      if (head.startsWith('%PDF-')) return 'application/pdf';
      if (bytes[0] === 0xFF && bytes[1] === 0xD8) return 'image/jpeg';
      if (bytes[0] === 0x89 && bytes[1] === 0x50 && bytes[2] === 0x4E && bytes[3] === 0x47) return 'image/png';
      if (head.startsWith('RIFF') && head.slice(8, 12) === 'WEBP') return 'image/webp';
      return '';
    };
    $('[data-documents]').addEventListener('click', async (event) => {
      const button = event.target.closest('[data-open-doc]');
      if (!button || !data) return;
      const doc = data.documents[Number(button.dataset.openDoc)];
      const url = doc && safeDocUrl(doc.download_url);
      if (!url) { showStatus(docStatus, 'Questo documento non è disponibile. Contattaci per riceverlo.', 'error'); return; }
      const win = window.open('', '_blank');
      if (win) { try { win.opener = null; win.document.title = 'Apertura documento…'; win.document.body.textContent = 'Apertura documento…'; } catch {} }
      button.disabled = true;
      showStatus(docStatus, '');
      let refreshed = false;
      try {
        // Ogni link vale una sola volta e al massimo 2 minuti: prima di aprire ne chiede uno nuovo.
        let openUrl = url;
        try {
          const fresh = await call('me');
          if (!token()) { if (win) win.close(); return; }
          data = fresh;
          refreshed = true;
          const again = (fresh.documents || []).find((d) => d.id === doc.id);
          const freshUrl = again && safeDocUrl(again.download_url);
          if (freshUrl) openUrl = freshUrl;
        } catch {}
        const res = await fetch(openUrl.href, { credentials: 'omit' });
        if (!res.ok) throw new Error('download');
        const bytes = new Uint8Array(await res.arrayBuffer());
        if (!token()) { if (win) win.close(); return; }
        const type = sniffType(bytes);
        if (!type) throw new Error('type');
        const blobUrl = URL.createObjectURL(new Blob([bytes], { type }));
        if (win) win.location.href = blobUrl;
        else { const a = document.createElement('a'); a.href = blobUrl; a.target = '_blank'; a.rel = 'noopener'; a.click(); }
        setTimeout(() => URL.revokeObjectURL(blobUrl), 120000);
      } catch (err) {
        if (err.message === 'type') {
          if (win) win.close();
          showStatus(docStatus, 'Il file ricevuto non è un documento valido. Contattaci.', 'error');
        } else {
          if (win) win.close();
          showStatus(docStatus, 'Non è stato possibile aprire il documento. Riprova tra qualche secondo.', 'error');
          load().catch(() => {});
        }
      } finally { button.disabled = false; if (refreshed && token()) render(); }
    });

    const tabButtons = $$('[data-tab]');
    tabButtons.forEach((b, index) => {
      b.addEventListener('click', () => setTab(b.dataset.tab));
      b.addEventListener('keydown', (event) => {
        let next = null;
        if (event.key === 'ArrowRight' || event.key === 'ArrowDown') next = (index + 1) % tabButtons.length;
        else if (event.key === 'ArrowLeft' || event.key === 'ArrowUp') next = (index - 1 + tabButtons.length) % tabButtons.length;
        else if (event.key === 'Home') next = 0;
        else if (event.key === 'End') next = tabButtons.length - 1;
        if (next !== null) { event.preventDefault(); setTab(tabButtons[next].dataset.tab, true); }
      });
    });

    const endSession = async (text, isError) => {
      // Prima si chiude tutto sullo schermo, poi si avvisa il server: i dati spariscono subito anche se la rete è lenta.
      const oldToken = token();
      sessionEpoch++;
      sessionRemove(key); sessionRemove(challengeKey); sessionRemove(loginAtKey);
      data = null;
      $('[data-practices]').replaceChildren();
      $('[data-documents]').replaceChildren();
      $('[data-privacy-list]').replaceChildren();
      $('[data-customer-name]').textContent = 'Area Cliente';
      $$('form').forEach(form => form.reset());
      $$('input, textarea').forEach(field => { if (field.name !== 'email') field.value = ''; });
      $('[data-app]').hidden = true;
      $('[data-login]').hidden = false;
      $('[data-otp-card]').hidden = true;
      $('[data-action="logout"]').hidden = true;
      $$('[data-form-status]').forEach(el => { el.hidden = true; el.textContent = ''; });
      topMessage(text, isError);
      let remoteOk = !oldToken;
      if (oldToken) {
        const controller = new AbortController();
        const limit = setTimeout(() => controller.abort(), 8000);
        try {
          const res = await fetch(`${api}?action=logout`, { method: 'POST', headers: { 'Content-Type': 'application/json', 'X-Bellucco-Token': oldToken }, body: '{}', credentials: 'omit', keepalive: true, signal: controller.signal });
          remoteOk = res.ok;
        } catch { remoteOk = false; } finally { clearTimeout(limit); }
        // L'uscita locale è già avvenuta; se il server non ha confermato lo diciamo chiaramente (la sessione scade comunque entro 30 minuti).
        if (!remoteOk && text) topMessage(text + ' Non è stato possibile confermare la chiusura al server: la sessione scade comunque automaticamente entro 30 minuti.', isError);
      }
      return remoteOk;
    };

    $('[data-action="logout"]').addEventListener('click', async (event) => {
      const button = event.currentTarget;
      if (button.disabled) return;
      button.disabled = true;
      try { await endSession('Uscita effettuata.', false); sessionRemove(emailKey); }
      finally { button.disabled = false; }
    });

    // Chiusura automatica dopo 30 minuti senza attività.
    ['click', 'keydown', 'scroll', 'touchstart'].forEach(type => document.addEventListener(type, () => { lastActivity = Date.now(); }, { passive: true }));
    const loginAt = () => { const v = Number(sessionRead(loginAtKey)); return Number.isFinite(v) && v > 0 ? v : 0; };
    const checkSession = () => {
      if (!token()) return;
      const started = loginAt();
      if (!started) { sessionWrite(loginAtKey, Date.now()); return; }
      if (Date.now() - started > SESSION_LIMIT_MS) endSession('Per sicurezza la sessione è scaduta: dura al massimo 30 minuti dall\'accesso. Richiedi un nuovo codice per rientrare.', true);
      else if (Date.now() - lastActivity > IDLE_LIMIT_MS) endSession('Per sicurezza la sessione è stata chiusa dopo 30 minuti di inattività. Richiedi un nuovo codice per rientrare.', true);
    };
    setInterval(checkSession, 60000);
    document.addEventListener('visibilitychange', () => { if (!document.hidden) checkSession(); });
    checkSession();

    root.querySelectorAll('[data-bb-js-enable]').forEach(control => {
      control.disabled = false;
      control.removeAttribute('data-bb-js-enable');
    });
    root.querySelectorAll('[data-bb-form-unavailable]').forEach(message => { message.hidden = true; });

    const emailField = $('[data-form="request-otp"] input[name="email"]'); if (emailField && email) emailField.value = email;
    if (token()) load().catch(error => {
      if (error.status === 401 || error.status === 403) {
        sessionRemove(key);
        topMessage('La sessione è scaduta. Richiedi un nuovo codice di accesso.', true);
      } else topMessage('Connessione non riuscita. Ricarica la pagina per riprovare.', true);
    });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bellucco-footer"] && !Shopify.designMode) return;
  try {
    
(() => {
  const bind = () => {
    document.querySelectorAll('[data-bb-cookie-settings]').forEach(button => {
      if (button.dataset.bound === 'true') return;
      button.dataset.bound = 'true';
      button.addEventListener('click', async () => {
        if (button.disabled) return;
        const status = button.parentElement.querySelector('[data-bb-cookie-status]');
        button.disabled = true;
        status.textContent = '';
        try {
          for (let attempt = 0; !window.privacyBanner?.showPreferences && attempt < 20; attempt++) {
            await new Promise(resolve => setTimeout(resolve, 250));
          }
          if (!window.privacyBanner?.showPreferences) throw new Error('privacy_unavailable');
          await window.privacyBanner.showPreferences();
        } catch {
          status.textContent = button.dataset.error;
        } finally {
          button.disabled = false;
        }
      });
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', bind, {once:true});
  else bind();
  document.addEventListener('shopify:section:load', bind);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bellucco-welcome-discount"]) return;
  try {
    
  (() => {
    const popup = document.getElementById('bb-welcome');
    if (!popup) return;
    const root = document.documentElement;
    const key = 'bb_welcome10_seen_v1';
    const ownReturn = location.hash.includes('bb-welcome') || new URLSearchParams(location.search).get('bb_signup') === 'welcome';
    const result = ownReturn && Boolean(popup.querySelector('[data-success]:not([hidden])'));
    const design = popup.dataset.design === 'true';
    let dismissed = false;
    let opened = false;
    let timer;
    let previousFocus = null;
    const menuOpen = () => Boolean(document.querySelector('header-drawer details[open], .menu-drawer-container[open], #Details-menu-drawer-container[open], .bellucco-desktop-menu[open]'));
    const viewport = window.visualViewport;
    const fitViewport = () => {
      const gap = viewport ? Math.max(0, window.innerHeight - viewport.height - viewport.offsetTop) : 0;
      popup.style.setProperty('--bb-keyboard', gap + 'px');
      popup.style.setProperty('--bb-visible-height', (viewport?.height || window.innerHeight) + 'px');
    };
    fitViewport();
    viewport?.addEventListener('resize', fitViewport);
    viewport?.addEventListener('scroll', fitViewport);
    const readSeen = () => { try { return sessionStorage.getItem(key) === '1'; } catch { return false; } };
    const markSeen = () => { try { sessionStorage.setItem(key, '1'); } catch {} };
    const visible = el => !el.hidden && getComputedStyle(el).display !== 'none' && getComputedStyle(el).visibility !== 'hidden' && el.getClientRects().length > 0;
    const privacyPending = () => {
      
      if ([...document.querySelectorAll('#shopify-pc__banner,#shopify-pc__prefs,[data-shopify-privacy-banner],[role="alertdialog"]')].some(visible)) return true;
      const api = window.Shopify?.customerPrivacy;
      if (!api?.shouldShowBanner) return root.classList.contains('bb-shopify-privacy-pending') || document.readyState !== 'complete';
      return Boolean(api.shouldShowBanner());
    };
    const close = () => {
      dismissed = true;
      clearTimeout(timer);
      const focused = popup.contains(document.activeElement);
      popup.hidden = true;
      root.classList.remove('bb-welcome-active');
      markSeen();
      if (focused) (previousFocus?.isConnected ? previousFocus : document.querySelector('#MainContent a, #MainContent button, .header-logo'))?.focus();
    };
    popup.querySelector('.bb-welcome-close').addEventListener('click', close);
    popup.addEventListener('keydown', event => { if (event.key === 'Escape') close(); });
    const path = window.location.pathname;
    if (!result && ['/cart','/account','/checkouts','/challenge','/pages/area-client','/pages/configuratore-impianto'].some(x => path.includes(x))) return;
    if (!result && readSeen() && !design) return;
    const offerReady = async () => {
      if ((await window.bbCatalogAvailability) !== true) return false;
      const controller = new AbortController();
      const timeout = setTimeout(() => controller.abort(), 5000);
      try {
        const response = await fetch('https://help.bellucco.net/portale/api/welcome-status', {
          mode: 'cors', credentials: 'omit', cache: 'no-store', signal: controller.signal
        });
        if (!response.ok) return false;
        const status = await response.json();
        return status.ok === true && status.ready === true;
      } catch {
        return false;
      } finally {
        clearTimeout(timeout);
      }
    };
    const blocked = () => {
      const editingElsewhere = document.activeElement?.matches('input, textarea, select, [contenteditable="true"]') && !popup.contains(document.activeElement);
      const dialogOpen = [...document.querySelectorAll('dialog[open], [aria-modal="true"]')].some(el => !popup.contains(el) && visible(el));
      return privacyPending() || menuOpen() || document.hidden || editingElsewhere || dialogOpen;
    };
    const showWhenReady = () => {
      if (dismissed) return;
      clearTimeout(timer);
      if (blocked()) {
        popup.hidden = true;
        root.classList.remove('bb-welcome-active');
        timer = setTimeout(showWhenReady, 800);
        return;
      }
      if (!opened) previousFocus = document.activeElement;
      root.classList.add('bb-welcome-active');
      popup.hidden = false;
      if (!opened && result) popup.querySelector('button')?.focus();
      opened = true;
      markSeen();
    };
    const sync = () => {
      if (dismissed || !opened || !blocked() || popup.hidden) return;
      popup.hidden = true;
      root.classList.remove('bb-welcome-active');
      clearTimeout(timer);
      timer = setTimeout(showWhenReady, 800);
    };
    document.addEventListener('visitorConsentCollected', sync);
    document.addEventListener('visibilitychange', sync);
    document.addEventListener('focusin', sync);
    document.addEventListener('keydown', event => {
      if (event.key === 'Escape' && !popup.hidden && !blocked()) close();
    });
    new MutationObserver(sync).observe(document.body, {childList:true,subtree:true,attributes:true,attributeFilter:['hidden','style','class','open']});
    offerReady().then(available => { if (available) timer = setTimeout(showWhenReady, result ? 0 : 2200); }).catch(() => {});
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
